// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3yOgL","inputWrap":"Table_inputWrap__3zDzS","col":"Table_col__1DgSE","bmiTooltip":"Table_bmiTooltip__2VckO"};